import StatusBadge from './StatusBadge';
import RangeBar from './RangeBar';
import Sparkline from './Sparkline';
import { getStatus, getStatusColor } from '../../utils/status';
import { formatLectura } from '../../utils/soilReading';

interface Props {
  name: string;
  /**
   * Clave del parámetro (humidity, temp…). Sirve para saber si el valor está
   * pegado al tope del sensor — ver utils/soilReading.ts. Opcional: sin ella
   * el número se pinta tal cual, que es el comportamiento de siempre.
   */
  paramKey?: string;
  value: number;
  unit: string;
  lo: number;
  hi: number;
  warnLo?: number;
  warnHi?: number;
  history: number[]; // últimos 20 puntos
  onClick?: () => void;
}

export default function ParameterCard({
  name,
  paramKey,
  value,
  unit,
  lo,
  hi,
  warnLo,
  warnHi,
  history,
  onClick,
}: Props) {
  const status = getStatus(value, lo, hi, warnLo, warnHi);
  const color = getStatusColor(status);

  return (
    <div
      onClick={onClick}
      style={{
        background: 'var(--white)',
        borderRadius: '12px',
        border: '0.5px solid var(--border)',
        padding: '14px',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'border-color 0.2s',
      }}
      onMouseEnter={(e) => {
        if (onClick) e.currentTarget.style.borderColor = 'var(--green)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'var(--border)';
      }}
    >
      {/* Icono + nombre */}
      <div style={{ fontSize: '12px', color: '#444', marginBottom: '8px' }}>
        {name}
      </div>

      {/* Valor grande */}
      <div style={{ fontSize: '22px', fontWeight: 600, color }}>
        {formatLectura(paramKey ?? '', value)}
      </div>

      {/* Unidad */}
      <div style={{ fontSize: '10px', color: 'var(--gray)', marginBottom: '6px' }}>
        {unit}
      </div>

      {/* Badge de status */}
      <div style={{ marginBottom: '10px' }}>
        <StatusBadge status={status} size="sm" />
      </div>

      {/* Barra de rango */}
      <RangeBar value={value} lo={lo} hi={hi} warnLo={warnLo} warnHi={warnHi} />

      {/* Sparkline */}
      <div style={{ marginTop: '10px' }}>
        <Sparkline data={history} color={color} />
      </div>
    </div>
  );
}
